<div class="login-container wrapper">
    <div class="block-center mt-4 wd-xl">
        <!-- START card-->
        <div class="card card-flat">
            <div class="card-header text-center bg-dark">
                <a href="#">
                    <img class="block-center rounded login-logo" src="assets/img/brand/logo.png" alt="Image" />
                </a>
            </div>
            <div class="card-body">
                <button class="btn btn-block btn-primary mt-3" (click)="login()">Login</button>

            </div>
        </div>
        <!-- END card-->
        <div class="p-3 text-center">
            <span>&copy;</span>
            <span>{{ settingsService.app.year }}</span>
            <span class="mx-2">-</span>
            <span>{{ settingsService.app.name }}</span>
            <br/>
            <span>{{ settingsService.app.description }}</span>
        </div>
    </div>
</div>
